module.exports = __webpack_public_path__ + "static/media/11NEPAD10.28d4b236.jpg";